module.exports = __webpack_public_path__ + "img/popup3.d9f0e47f.png";